import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function PriceBlock() {
  return <section id="precio" className="w-full bg-[#2D8C5A] py-20 md:py-24 px-6" data-id="element-65">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-2xl mx-auto text-center" data-id="element-66">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-67">
          Recuperá la paz de tu hogar hoy mismo
        </h2>
        <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed" data-id="element-68">
          Por menos de lo que cuesta un kilo de piedras premium, llevate el
          sistema completo que salvará tu sofá y tu relación con tu gato.
        </p>

        <div className="bg-white rounded-2xl p-8 md:p-10 mb-8" data-id="element-69">
          <div className="mb-6" data-id="element-70">
            <div className="text-5xl md:text-6xl font-['Playfair_Display'] font-bold text-[#1C1C1C] mb-2" data-id="element-71">
              $8.599
            </div>
            <div className="text-lg text-[#1C1C1C]/70" data-id="element-72">
              Pago único - Descarga inmediata
            </div>
          </div>

          <motion.a href="https://amigospeludosarg.shop/cart/48933114577138:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-[#2D8C5A] text-white font-semibold px-8 py-5 rounded-lg text-xl hover:bg-[#267049] transition-colors mb-6 text-center cursor-pointer" data-id="element-73">
            QUIERO RECUPERAR MI CASA AHORA
          </motion.a>

          <div className="flex items-center justify-center gap-2 text-[#1C1C1C]/70" data-id="element-74">
            <ShieldCheckIcon className="w-5 h-5" data-id="element-75" />
            <span className="text-sm" data-id="element-76">
              Compra 100% segura. Recibís el PDF en tu email al instante.
            </span>
          </div>
        </div>
      </motion.div>
    </section>;
}